/**
 * Checks if a given return URL is valid.
 *
 * This function ensures that the return URL is relative and does not pose
 * security risks such as open redirect vulnerabilities. It performs the following checks:
 * - The URL must start with a single forward slash ('/').
 * - The URL must not start with a double forward slash ('//') to prevent protocol-relative URLs.
 * - The URL must not start with '/\\' to prevent backslash-based protocol-relative URLs.
 * - The URL must not start with '/auth' to avoid redirect loops.
 *
 * @param {string | null | undefined} returnUrl - The return URL to validate.
 * @returns {boolean} - Returns `true` if the return URL is valid, otherwise `false`.
 */
export function isValidReturnUrl(
  returnUrl: string | null | undefined,
): returnUrl is string {
  if (!returnUrl?.startsWith) {
    return false
  }
  return (
    returnUrl.startsWith('/') && // we make sure that the return url is relative to avoid open redirect vulnerabilities
    !returnUrl.startsWith('//') && // double slash because some browsers interpret it as protocol relative URL
    !returnUrl.startsWith('/\\') && // backslash because some browsers interpret it as protocol relative URL
    !returnUrl.startsWith('/auth') // to avoid redirect loops
  )
}
